module.exports = __webpack_public_path__ + "static/yalda-9b0da99f9acf1a6dd88661973f080654.png";